import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://sistemafinanciero.digitaleseduproperu.com/api';

const getToken = () => localStorage.getItem('token');

const headers = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

const EMPTY = {
  codigo: '', nombres: '', apellidos: '', dni: '',
  fecha_nacimiento: '', sexo: '', direccion: '', telefono: '',
  email: '', cargo: '', departamento: '', fecha_ingreso: '',
  tipo_contrato: '', sueldo_base: '', estado: 'activo', foto_base64: '',
};

export default function EmpleadosPage() {
  const [empleados, setEmpleados] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState('activo');
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDetalle, setShowDetalle] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [detalle, setDetalle] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { cargar(); }, [filtroEstado, search]);

  const cargar = async () => {
    try {
      const params = {};
      if (filtroEstado) params.estado = filtroEstado;
      if (search) params.search = search;
      const res = await axios.get(`${API}/empleados`, { headers: headers(), params });
      setEmpleados(res.data);
    } catch (e) { console.error(e); }
  };

  const abrirNuevo = () => {
    setForm(EMPTY); setEditId(null); setError(''); setShowModal(true);
  };

  const abrirEditar = (emp) => {
    setForm({
      codigo: emp.codigo || '', nombres: emp.nombres || '',
      apellidos: emp.apellidos || '', dni: emp.dni || '',
      fecha_nacimiento: emp.fecha_nacimiento ? emp.fecha_nacimiento.substring(0,10) : '',
      sexo: emp.sexo || '', direccion: emp.direccion || '',
      telefono: emp.telefono || '', email: emp.email || '',
      cargo: emp.cargo || '', departamento: emp.departamento || '',
      fecha_ingreso: emp.fecha_ingreso ? emp.fecha_ingreso.substring(0,10) : '',
      tipo_contrato: emp.tipo_contrato || '',
      sueldo_base: emp.sueldo_base || '',
      estado: emp.estado || 'activo',
      foto_base64: emp.foto_base64 || '',
    });
    setEditId(emp.id); setError(''); setShowModal(true);
  };

  const abrirDetalle = async (id) => {
    try {
      const res = await axios.get(`${API}/empleados/${id}`, { headers: headers() });
      setDetalle(res.data); setShowDetalle(true);
    } catch (e) { console.error(e); }
  };

  const guardar = async () => {
    if (!form.codigo || !form.nombres || !form.apellidos || !form.dni ||
        !form.fecha_ingreso || !form.tipo_contrato || !form.sueldo_base) {
      setError('Complete los campos obligatorios.'); return;
    }
    setLoading(true);
    try {
      if (editId) {
        await axios.put(`${API}/empleados/${editId}`, form, { headers: headers() });
      } else {
        await axios.post(`${API}/empleados`, form, { headers: headers() });
      }
      setShowModal(false); cargar();
    } catch (e) {
      setError(e.response?.data?.message || 'Error al guardar.');
    } finally { setLoading(false); }
  };

  const cesar = async (id) => {
    if (!window.confirm('¿Cesar este empleado?')) return;
    try {
      await axios.delete(`${API}/empleados/${id}`, { headers: headers() });
      cargar();
    } catch (e) { console.error(e); }
  };

  const handleFoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setForm(f => ({ ...f, foto_base64: reader.result }));
    reader.readAsDataURL(file);
  };

  const estadoBadge = (estado) => {
    const map = { activo: 'success', inactivo: 'warning', cesado: 'danger' };
    return <span className={`badge bg-${map[estado] || 'secondary'}`}>{estado}</span>;
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">
          <i className="fas fa-users me-2 text-primary"></i>Empleados
        </h2>
        <button className="btn btn-primary" onClick={abrirNuevo}>
          <i className="fas fa-plus me-2"></i>Nuevo Empleado
        </button>
      </div>

      {/* Filtros */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <input
                type="text" className="form-control"
                placeholder="Buscar por nombre, apellido, DNI o código..."
                value={search} onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <select className="form-select" value={filtroEstado}
                onChange={e => setFiltroEstado(e.target.value)}>
                <option value="">Todos los estados</option>
                <option value="activo">Activo</option>
                <option value="inactivo">Inactivo</option>
                <option value="cesado">Cesado</option>
              </select>
            </div>
            <div className="col-md-3">
              <span className="text-muted">{empleados.length} empleado(s)</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla */}
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>Código</th>
                  <th>Empleado</th>
                  <th>DNI</th>
                  <th>Cargo</th>
                  <th>Departamento</th>
                  <th>Sueldo Base</th>
                  <th>Contrato</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {empleados.length === 0 ? (
                  <tr><td colSpan={9} className="text-center py-4 text-muted">
                    No hay empleados registrados.
                  </td></tr>
                ) : empleados.map(emp => (
                  <tr key={emp.id}>
                    <td><code>{emp.codigo}</code></td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        {emp.foto_base64
                          ? <img src={emp.foto_base64} alt="" width={32} height={32}
                              style={{borderRadius:'50%', objectFit:'cover'}} />
                          : <div style={{width:32,height:32,borderRadius:'50%',
                              background:'#e9ecef',display:'flex',alignItems:'center',
                              justifyContent:'center',fontSize:14}}>
                              <i className="fas fa-user text-muted"></i>
                            </div>
                        }
                        <div>
                          <div className="fw-semibold">{emp.apellidos}, {emp.nombres}</div>
                          <small className="text-muted">{emp.email}</small>
                        </div>
                      </div>
                    </td>
                    <td>{emp.dni}</td>
                    <td>{emp.cargo || '—'}</td>
                    <td>{emp.departamento || '—'}</td>
                    <td className="fw-semibold">
                      S/ {parseFloat(emp.sueldo_base || 0).toFixed(2)}
                    </td>
                    <td>
                      <span className="badge bg-light text-dark border">
                        {emp.tipo_contrato}
                      </span>
                    </td>
                    <td>{estadoBadge(emp.estado)}</td>
                    <td>
                      <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-outline-info"
                          onClick={() => abrirDetalle(emp.id)} title="Ver detalle">
                          <i className="fas fa-eye"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-primary"
                          onClick={() => abrirEditar(emp)} title="Editar">
                          <i className="fas fa-edit"></i>
                        </button>
                        {emp.estado !== 'cesado' && (
                          <button className="btn btn-sm btn-outline-danger"
                            onClick={() => cesar(emp.id)} title="Cesar">
                            <i className="fas fa-user-times"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Formulario */}
      {showModal && (
        <div className="modal show d-block" style={{background:'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editId ? 'Editar Empleado' : 'Nuevo Empleado'}
                </h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                {/* Foto */}
                <div className="text-center mb-3">
                  {form.foto_base64
                    ? <img src={form.foto_base64} alt="" width={80} height={80}
                        style={{borderRadius:'50%', objectFit:'cover', border:'3px solid #dee2e6'}} />
                    : <div style={{width:80,height:80,borderRadius:'50%',background:'#e9ecef',
                        display:'flex',alignItems:'center',justifyContent:'center',
                        margin:'0 auto',fontSize:28}}>
                        <i className="fas fa-user text-muted"></i>
                      </div>
                  }
                  <div className="mt-2">
                    <label className="btn btn-sm btn-outline-secondary">
                      <i className="fas fa-camera me-1"></i>Foto
                      <input type="file" accept="image/*" hidden onChange={handleFoto} />
                    </label>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Código *</label>
                    <input className="form-control" value={form.codigo}
                      onChange={e => setForm(f => ({...f, codigo: e.target.value}))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">DNI *</label>
                    <input className="form-control" value={form.dni}
                      onChange={e => setForm(f => ({...f, dni: e.target.value}))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Sexo</label>
                    <select className="form-select" value={form.sexo}
                      onChange={e => setForm(f => ({...f, sexo: e.target.value}))}>
                      <option value="">Seleccionar</option>
                      <option value="masculino">Masculino</option>
                      <option value="femenino">Femenino</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Nombres *</label>
                    <input className="form-control" value={form.nombres}
                      onChange={e => setForm(f => ({...f, nombres: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Apellidos *</label>
                    <input className="form-control" value={form.apellidos}
                      onChange={e => setForm(f => ({...f, apellidos: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" value={form.email}
                      onChange={e => setForm(f => ({...f, email: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Teléfono</label>
                    <input className="form-control" value={form.telefono}
                      onChange={e => setForm(f => ({...f, telefono: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Cargo</label>
                    <input className="form-control" value={form.cargo}
                      onChange={e => setForm(f => ({...f, cargo: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Departamento</label>
                    <input className="form-control" value={form.departamento}
                      onChange={e => setForm(f => ({...f, departamento: e.target.value}))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Fecha Nacimiento</label>
                    <input type="date" className="form-control" value={form.fecha_nacimiento}
                      onChange={e => setForm(f => ({...f, fecha_nacimiento: e.target.value}))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Fecha Ingreso *</label>
                    <input type="date" className="form-control" value={form.fecha_ingreso}
                      onChange={e => setForm(f => ({...f, fecha_ingreso: e.target.value}))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Tipo Contrato *</label>
                    <select className="form-select" value={form.tipo_contrato}
                      onChange={e => setForm(f => ({...f, tipo_contrato: e.target.value}))}>
                      <option value="">Seleccionar</option>
                      <option value="indefinido">Indefinido</option>
                      <option value="plazo_fijo">Plazo Fijo</option>
                      <option value="practicas">Prácticas</option>
                      <option value="locacion">Locación de Servicios</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Sueldo Base (S/) *</label>
                    <input type="number" className="form-control" value={form.sueldo_base}
                      onChange={e => setForm(f => ({...f, sueldo_base: e.target.value}))} />
                  </div>
                  {editId && (
                    <div className="col-md-4">
                      <label className="form-label">Estado</label>
                      <select className="form-select" value={form.estado}
                        onChange={e => setForm(f => ({...f, estado: e.target.value}))}>
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                        <option value="cesado">Cesado</option>
                      </select>
                    </div>
                  )}
                  <div className="col-12">
                    <label className="form-label">Dirección</label>
                    <textarea className="form-control" rows={2} value={form.direccion}
                      onChange={e => setForm(f => ({...f, direccion: e.target.value}))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={guardar} disabled={loading}>
                  {loading ? 'Guardando...' : (editId ? 'Actualizar' : 'Registrar')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detalle */}
      {showDetalle && detalle && (
        <div className="modal show d-block" style={{background:'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detalle del Empleado</h5>
                <button className="btn-close" onClick={() => setShowDetalle(false)}></button>
              </div>
              <div className="modal-body">
                <div className="text-center mb-3">
                  {detalle.foto_base64
                    ? <img src={detalle.foto_base64} alt="" width={90} height={90}
                        style={{borderRadius:'50%', objectFit:'cover'}} />
                    : <div style={{width:90,height:90,borderRadius:'50%',background:'#e9ecef',
                        display:'flex',alignItems:'center',justifyContent:'center',
                        margin:'0 auto',fontSize:34}}>
                        <i className="fas fa-user text-muted"></i>
                      </div>
                  }
                  <h5 className="mt-2 mb-0">{detalle.apellidos}, {detalle.nombres}</h5>
                  <small className="text-muted">{detalle.cargo}</small>
                  <div className="mt-1">{estadoBadge(detalle.estado)}</div>
                </div>
                <table className="table table-sm">
                  <tbody>
                    <tr><th>Código</th><td><code>{detalle.codigo}</code></td></tr>
                    <tr><th>DNI</th><td>{detalle.dni}</td></tr>
                    <tr><th>Email</th><td>{detalle.email || '—'}</td></tr>
                    <tr><th>Teléfono</th><td>{detalle.telefono || '—'}</td></tr>
                    <tr><th>Departamento</th><td>{detalle.departamento || '—'}</td></tr>
                    <tr><th>Contrato</th><td>{detalle.tipo_contrato}</td></tr>
                    <tr><th>Sueldo Base</th>
                      <td className="fw-bold text-success">
                        S/ {parseFloat(detalle.sueldo_base || 0).toFixed(2)}
                      </td>
                    </tr>
                    <tr><th>Ingreso</th><td>{detalle.fecha_ingreso?.substring(0,10)}</td></tr>
                    {detalle.fecha_cese && (
                      <tr><th>Cese</th><td>{detalle.fecha_cese?.substring(0,10)}</td></tr>
                    )}
                    <tr><th>Dirección</th><td>{detalle.direccion || '—'}</td></tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowDetalle(false)}>
                  Cerrar
                </button>
                <button className="btn btn-primary" onClick={() => {
                  setShowDetalle(false); abrirEditar(detalle);
                }}>
                  <i className="fas fa-edit me-1"></i>Editar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}